import { MultiCountryData } from '../shared/models/multi-country-data';

export const environment = {
    /** Identificador de la landing: define sus países en src/shared/constants/landings.ts */
    landing: 'linkDelivery',
    lastLanguage: 'es',
    currentLanguage: 'es',
    production: true,
    version: '2.1.6.0-20240822-qa',
    test: 'qa',
    googleAnalytics: 'G-L2G7FL9MP3',
    googleAnalyticsTechnical: 'G-JX2GHBQLYG',
    rol: '',
    expressUserData: [],
    pathCertificate: 'assets/certs/public-qa.txt',
    multiCountryData: [] as MultiCountryData[],
    basePath: '/',
    apigoogle: 'AIzaSyBLMW-yZQI4A_mnrDCugdzhMl1RPLjrJ4w',
    linkEntregaPage: 'https://linkdepago.forzadelivery.com',
    apiLinkEntrega: 'https://backendlinkpago.forzadelivery.com/api/V1',
    apiBackApp: 'https://backendlinkpago.forzadelivery.com/app/api/V1',
    linkQrAfiliatePage: 'https://qa.portal.forzadelivery.com/clubForza/',
    storeLink: 'https://qa.tienda.forzadelivery.com',
    routes: [
        {
            path: ':token',
            loadComponent: () =>
                import('../pages/delivery-link/delivery-link.component').then(
                    (m) => m.DeliveryLinkComponent
                ),
        },
        {
            path: 'pagina-no-encontrada',
            loadComponent: () =>
                import('../pages/not-found/not-found.component').then(
                    (m) => m.NotFoundComponent
                ),
        },
        {
            path: '**',
            loadComponent: () =>
                import('../pages/not-found/not-found.component').then(
                    (m) => m.NotFoundComponent
                ),
        },
    ],
};

export enum Constants {
    api = 'https://qa-linkdepago.forzadeliveryexpress.com/fd/Home.aspx/API',
    api2 = 'https://qa-linkdepago.forzadeliveryexpress.com/fd/Home.aspx/API',
    apiHN = 'https://qa.linkdepago.forzadelivery.com/fdHN/Home.aspx/API',
    sesionTime = 900000, // 15 * 60 * 1000 = 900000 milisegundos = 15 minutos
    sesionTimeExpress = 32400000, // 9 horas * 60 minutos  * 60 segundos * 1000 milisegundos = 32400000
}
